import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import HeaderColumn from './HeaderColumn.js';
import HeaderRow from './HeaderRow.js';

/**
 * Header di un component Table.
 */
function Header({ children, className }) {
    return (jsx("thead", { className: cns('table__head', className), children: children }));
}
Header.defaultProps = {
    children: null,
    className: '',
};
Header.Row = HeaderRow;
Header.Column = HeaderColumn;

export { Header as default };
